// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module__root___1hQSj"};